import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormField } from 'src/app/services/text-control.service.interface';

@Component({
  selector: 'tx-debug-dialog',
  templateUrl: './debug-dialog.component.html',
  styleUrls: ['./debug-dialog.component.scss'],
})
export class DebugDialogComponent {
  @Input() firmId: string = '';
  @Input() sessionId: string = '';
  @Input() contactId: string = '';
  @Input() caseId: string = '';
  @Input() documentId: string = '';
  @Input() answerPoolId: string = '';
  @Input() appInsightsSessionId: string = '';
  @Input() selectedField: FormField | undefined;

  constructor(public activeModal: NgbActiveModal) {}

  getDetailsText() {
    return this.selectedField!.details.text ? this.selectedField!.details.text : 'No Answer Given Yet';
  }
}

